import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsTable } from "react-icons/bs";
import { PDFExport } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import {
  exportToTxt,
  generateExcel,
  numberWithCommas,
} from "../../utils/customFunction";
import { useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
import CardColComponent from "../genericCardComponent/CardColComponent";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import moment from "moment";
import HBLLogo from "../../assets/image.png";
import DividendCard from "../dividend/AnnouncementListing";
import { getFundByAmc, getFunds } from "../../stores/services/funds.service";
import Select from "react-select";
import { getAllProvidentFunds } from "../../stores/services/provident-funds.service";
import { getAllCompanies } from "../../stores/services/company.service";
import { useCustomStylesDropDown } from "../../assets/css/customStyle";

function PFFundSummaryReport() {
  const ColumnHeading = [
    {
      label: "Fund Code",
      value: "Fund Code",
    },
    {
      label: "Month",
      value: "Month",
    },
    // {
    //     label: "Employee Code",
    //     value: "Employee Code",
    // },
    // {
    //     label: "Employee Name",
    //     value: "Employee Name",
    // },
    // {
    //     label: "CNIC",
    //     value: "CNIC",
    // },
    {
      label: "Employee Contribution",
      value: "Employee Contribution",
    },
    {
      label: "Employer Contribution",
      value: "Employer Contribution",
    },
    {
      label: "Profit",
      value: "Profit",
    },
    {
      label: "Adjustment",
      value: "Adjustment",
    },
    {
      label: "Total",
      value: "Total",
    },
    {
      label: "Remarks",
      value: "Remarks",
    },
  ];
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const contentRef = React.useRef(null);
  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: [],
  });
  const [fontSizeVal, setFontSizeVal] = useState(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [fromDate, setFromDate] = useState<any>(moment().format("YYYY-MM"));
  const [toDate, setToDate] = useState<any>(moment().format("YYYY-MM"));
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState<any>();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const pdfExportComponent = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [fund, setFund] = useState("");
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [searchCode, setSearchCode] = useState<any>("");
  const [searchName, setSearchName] = useState<any>("");
  const [summary, setSummary] = useState<any>({
    totalEmployeeContribution: 0,
    totalEmployerContribution: 0,
    totalProfit: 0,
    totalAdjustment: 0,
    grandTotal: 0,
  });
  const [overallSummary, setOverallSummary] = useState<any>();
  const [folio, setFolio] = useState<any>("");
  const [allFolios, setAllFolios] = useState<any[]>([]);
  const [loadingCompany, setLoadingCompany] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState<any>();

  // Fetch Companies
  useEffect(() => {
    const fetchAllCompanies = async () => {
      try {
        setLoadingCompany(true);
        const resp = await getAllCompanies({ email, fetch_all: "all" });
        if (resp.data.status === 200) {
          const options = resp.data.data.map((data: any) => ({
            ...data,
            value: data.company_code,
            label: `${data.name_of_company} (${data.company_code})`,
          }));
          setCompanyOptions(options);
        }
      } catch (error) {
        toast.error("Failed to load companies");
      } finally {
        setLoadingCompany(false);
      }
    };
    fetchAllCompanies();
  }, []);

  // Fetch Funds when Company changes
  useEffect(() => {
    const getAllFunds = async () => {
      if (!companyName?.value) return;
      try {
        const res = await getFunds({
          email,

          company_name: companyName.value,
        });
        setAllFunds(res.data.data || []);
      } catch (error) {
        toast.error("Failed to load funds");
      }
    };
    getAllFunds();
  }, [companyName]);

  const searchData = async () => {
    try {
      setLoading(true);
      const response = await getAllProvidentFunds(
        email,
        amc_code,
        fund,
        folio?.value || "",
        toDate,
        fromDate,
        searchName,
        "true"
      );
      if (response.data.status == 200 && response?.data?.data?.length > 0) {
        // const dataIs = response?.data?.data;
        const totalData = response?.data?.total;
        setOverallSummary({
          total_employee_contribution: totalData?.overall_employee_contribution,
          total_employer_contribution: totalData?.overall_employer_contribution,
          total_profit: totalData?.overall_profit,
          total: totalData?.overall_total,
        });
        setTableData(response?.data?.data);

        // const totalEmployeeContribution = dataIs?.reduce(
        //   (sum, item) => sum + parseFloat(item?.employee_contribution || 0),
        //   0
        // );
        // const totalEmployerContribution = dataIs?.reduce(
        //   (sum, item) => sum + parseFloat(item?.employer_contribution || 0),
        //   0
        // );
        // const totalProfit = dataIs?.reduce(
        //   (sum, item) => sum + parseFloat(item?.profit || 0),
        //   0
        // );
        // const grandTotal = dataIs?.reduce(
        //   (sum, item) => sum + parseFloat(item?.total || 0),
        //   0
        // );

        setSummary({
          totalEmployeeContribution: totalData.overall_employee_contribution,
          totalEmployerContribution: totalData.overall_employer_contribution,
          totalProfit: totalData?.overall_profit,
          grandTotal: totalData?.overall_total,
          totalAdjustment: totalData?.overall_adjustment,
        });
      } else {
        setTableData([]);
        toast.error("No record found!");
      }
    } catch (error: any) {
      setTableData([]);
      toast.error("No record found!");
    } finally {
      setLoading(false);
    }
  };

  const getAllEmployees = async (fundIs: string) => {
    try {
      if (!fundIs) {
        setAllFolios([]);
        return;
      }

      const response = await getAllProvidentFunds(email, amc_code, fundIs);
      if (response.data.status === 200) {
        setAllFolios(
          response.data.data.map((data) => {
            return {
              ...data,
              label: `${data.employee_name} (${data.folio_no})`,
              value: data.folio_no,
            };
          }) || []
        );
      }
    } catch (error) {
      toast.error("Failed to load employees.");
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test"
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, selectedValues, loading]);

  const fixedOrder = [
    "Month",
    "Employee Code",
    "Employee Name",
    "CNIC",
    "Employee Contribution",
    "Employer Contribution",
    "Profit",
    "Adjustment",
    "Total",
    "Remarks",
  ];

  const reorderColumns = (columns, order) => {
    return order.filter((column) => columns.includes(column));
  };

  // Excel Export Function
  const handleDownloadExcel = () => {
    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData = tableData.map((entry) => {
      const result = {};
      reorderedColumns.forEach((column) => {
        result[column] = entry[column] || "";
      });
      return result;
    });

    generateExcel(
      "PF Funds Report",
      "PF Funds Report",
      "File",
      "File",
      "DCCL",
      [],
      reorderedColumns,
      ArrayData,
      [],
      []
    );
  };

  // TXT Export Function
  const handleTXT = () => {
    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );
    const ArrayData = tableData.map((entry) => {
      const result = {};
      reorderedColumns.forEach((column) => {
        result[column] = entry[column] || "";
      });
      return result;
    });

    exportToTxt("", selectedValues, ArrayData, "PF Funds Report");
  };

  // PDF Export Function
  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "PF-Funds-Report.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 20, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(128, 128, 128);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          pdf.text(
            "This is a computer-generated report from MACS 360. No signature is required.",
            pageWidth / 2,
            pageHeight - 10,
            { align: "right" }
          );
        }
      })
      .save();
  };

  const renderFundsDropdown = () => {
    let temp: any = [];
    temp = allFunds.map((item: any, index: string) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
    return temp;
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds.find((item) => item?.symbol_code === fund);
    return selectedFund && selectedFund.nature === "Special Managed Account"
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
        }
      : selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
        }
      : null;
  }, [allFunds, fund]);

  const { customStyles } = useCustomStylesDropDown();

  const decentStyle = (valueIs) => {
    return (
      <CardColComponent
        subTitle={valueIs}
        simple={true}
        amount={true}
        forTxn={true}
      />
    );
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      Employee Monthly Contribution Report
                    </h4>
                  </div>
                  <div className="card-body">
                    <Row className="align-items-center">
                      <Col className="form-group col-md-3">
                        <label>
                          Company Name <span className="color-amber">*</span>
                        </label>
                        <Select
                          className="react-select info"
                          isLoading={loadingCompany}
                          value={companyName}
                          onChange={setCompanyName}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll
                          isClearable
                          isSearchable
                          options={companyOptions}
                          styles={customStyles}
                        />
                      </Col>

                      <Col md="3" xs="12" className="mb-3 mb-md-0">
                        <div className="form-group">
                          <label>Fund</label>
                          {fundLoading ? (
                            <div className="form-control w-100">
                              <i className="fa fa-spinner fa-spin fa-1x"></i>
                            </div>
                          ) : (
                            <Select
                              disabled={!companyName?.value}
                              value={selectedFundName}
                              label={fundLoading ? "Loading..." : "Select Fund"}
                              onChange={(e) => {
                                setFund(e?.value);
                                getAllEmployees(e?.value || "");
                              }}
                              menuPortalTarget={document.body}
                              menuShouldBlockScroll={true}
                              isClearable={true}
                              isSearchable={true}
                              name="color"
                              options={renderFundsDropdown()}
                              styles={customStyles}
                            />
                          )}
                        </div>
                      </Col>

                      <Col md="3" xs="12" className="mb-3 mb-md-0">
                        <div className="form-group">
                          <label htmlFor="pf-date">From Year</label>
                          <input
                            style={{
                              colorScheme: theme === "light" ? "light" : "dark",
                            }}
                            type="month"
                            className="form-control py-1"
                            value={fromDate}
                            onChange={(e) => {
                              setTableData([]);
                              setFromDate(e.target.value);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="3" xs="12" className="mb-3 mb-md-0">
                        <div className="form-group">
                          <label htmlFor="pf-date">To Year</label>
                          <input
                            style={{
                              colorScheme: theme === "light" ? "light" : "dark",
                            }}
                            type="month"
                            className="form-control py-1"
                            value={toDate}
                            onChange={(e) => {
                              setTableData([]);
                              setToDate(e.target.value);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="3" xs="12" className="mb-3 mb-md-0">
                        <div className="form-group">
                          <label>Select Employee</label>
                          <Select
                            value={folio}
                            onChange={(e) => setFolio(e || "")}
                            isClearable
                            isSearchable
                            options={allFolios}
                            styles={customStyles}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll
                          />
                        </div>
                      </Col>

                      <Col
                        md="auto"
                        xs="6"
                        className="d-flex align-items-end mt-3 mb-md-0"
                      >
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            if (fund == "" || fund == undefined) {
                              toast.error("Fund should not be empty");
                              return;
                            } else if (!folio?.value) {
                              toast.error("Please select Employee");
                              return;
                            } else {
                              searchData();
                            }
                          }}
                          disabled={Boolean(loading)}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Loading...</span>
                            </>
                          ) : (
                            <span>Search</span>
                          )}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </div>

                <div className="card mt-3">
                  <div className="card-body">
                    {tableData?.length > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={"PF-Funds-Report.pdf"}
                          printExcel={handleDownloadExcel}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}

                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${
                            dimensionOfPages?.find(
                              (item) => item?.key == paperSizeVal
                            )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                          }`,
                          height: "auto",
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <div
                          style={{
                            margin: "0.25in",
                          }}
                          ref={contentRef}
                        >
                          {tableData.length > 0 ? (
                            <>
                              <div className="row align-items-center">
                                <div className="col-4 d-flex justify-content-start">
                                  <img
                                    // src={companyName?.company_logo ? companyName?.company_logo : HBLLogo}
                                    src={
                                      companyName?.company_logo
                                        ? companyName?.company_logo
                                        : ""
                                    }
                                    alt="Vertices-Logo"
                                    style={{
                                      width: "auto",
                                      height: "33px",
                                    }}
                                  />
                                </div>
                                <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                                  <h6 className="text-black mt-2 mb-0">
                                    Employee Monthly Contribution Report
                                  </h6>
                                  <span>
                                    {moment(fromDate)?.format("MMM, YYYY")} –{" "}
                                    {moment(toDate)?.format("MMM, YYYY")}
                                  </span>
                                </div>
                              </div>
                              {/* <ReportHeader title="Provident Fund Report" /> */}
                              <DividendCard
                                unitholderDetails={summary}
                                allDetails={tableData}
                                reportName={"PFFundSummary"}
                                report={true}
                                employeeReport={true}
                              />
                              <div>
                                <table
                                  className=""
                                  style={{
                                    color: "black",
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black",
                                      }}
                                    >
                                      {selectedValues?.columns?.includes(
                                        "Fund Code"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Fund
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Month"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Month
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Employee Contribution"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Employee Contribution
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Employer Contribution"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Employer Contribution
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Profit"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Profit
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Adjustment"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Adjustmemt
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Total"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Total
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Remarks"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "11%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          Remarks
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody className="">
                                    {tableData.map((item: any, index) => (
                                      <tr className="border-bottom" key={index}>
                                        {selectedValues?.columns?.includes(
                                          "Fund Code"
                                        ) && (
                                          <td
                                            style={{
                                              width: "10%",
                                            }}
                                            id="test"
                                          >
                                            {item?.symbol_code}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Month"
                                        ) && (
                                          <td
                                            style={{
                                              width: "10%",
                                            }}
                                            id="test"
                                          >
                                            {moment(
                                              item?.month_of_contribution
                                            )?.format("MMM, YYYY")}
                                          </td>
                                        )}

                                        {selectedValues?.columns?.includes(
                                          "Employee Contribution"
                                        ) && (
                                          <td
                                            style={{
                                              width: "12%",
                                            }}
                                            id="test"
                                            className="text-right"
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item?.employee_contribution ||
                                                    0
                                                )?.toFixed(2)
                                              )
                                            )}
                                            {/* {numberWithCommas(
                                                parseFloat(
                                                  item?.employee_contribution || 0
                                                )?.toFixed(2)
                                              )} */}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Employer Contribution"
                                        ) && (
                                          <td
                                            style={{
                                              width: "12%",
                                            }}
                                            id="test"
                                            className="text-right"
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item?.employer_contribution ||
                                                    0
                                                )?.toFixed(2)
                                              )
                                            )}
                                            {/* {numberWithCommas(
                                                parseFloat(
                                                  item?.employer_contribution || 0
                                                )?.toFixed(2)
                                              )} */}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Profit"
                                        ) && (
                                          <td
                                            style={{
                                              width: "10%",
                                            }}
                                            id="test"
                                            className="text-right"
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item?.profit || 0
                                                )?.toFixed(2)
                                              )
                                            )}
                                            {/* {numberWithCommas(
                                                parseFloat(
                                                  item?.profit || 0
                                                )?.toFixed(2)
                                              )} */}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Adjustment"
                                        ) && (
                                          <td
                                            style={{
                                              width: "10%",
                                            }}
                                            id="test"
                                            className="text-right"
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item?.adjustment || 0
                                                )?.toFixed(2)
                                              )
                                            )}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Total"
                                        ) && (
                                          <td
                                            style={{
                                              width: "10%",
                                            }}
                                            id="test"
                                            className="text-right"
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item?.total || 0
                                                )?.toFixed(2)
                                              )
                                            )}
                                            {/* {numberWithCommas(
                                                parseFloat(
                                                  item?.total || 0
                                                )?.toFixed(2)
                                              )} */}
                                          </td>
                                        )}
                                        {selectedValues?.columns?.includes(
                                          "Remarks"
                                        ) && (
                                          <td
                                            style={{
                                              width: "11%",
                                            }}
                                            id="test"
                                            className="text-left"
                                          >
                                            {item?.remarks}
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>

                                  {/* Summary Footer */}
                                  <tfoot>
                                    <tr
                                      style={{ borderTop: "2px solid black" }}
                                    >
                                      {selectedValues?.columns?.includes(
                                        "Fund Code"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Total
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Month"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                            fontWeight: "bold",
                                          }}
                                        ></th>
                                      )}

                                      {selectedValues?.columns?.includes(
                                        "Employee Contribution"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                summary.totalEmployeeContribution ||
                                                  0
                                              ).toFixed(2)
                                            )
                                          )}
                                          {/* {numberWithCommas(
                                              parseFloat(
                                                summary.totalEmployeeContribution ||
                                                0
                                              ).toFixed(2)
                                            )} */}
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Employer Contribution"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                summary?.totalEmployerContribution ||
                                                  0
                                              )?.toFixed(2)
                                            )
                                          )}
                                          {/* {numberWithCommas(
                                              parseFloat(
                                                summary?.totalEmployerContribution ||
                                                0
                                              )?.toFixed(2)
                                            )} */}
                                        </th>
                                      )}

                                      {selectedValues?.columns?.includes(
                                        "Profit"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                summary?.totalProfit
                                              )?.toFixed(2)
                                            )
                                          )}
                                          {/* {numberWithCommas(
                                              parseFloat(
                                                summary?.totalProfit
                                              )?.toFixed(2)
                                            )} */}
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Adjustment"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                summary?.totalAdjustment
                                              )?.toFixed(2)
                                            )
                                          )}
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Total"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                summary?.grandTotal || 0
                                              )?.toFixed(2)
                                            )
                                          )}
                                          {/* {numberWithCommas(
                                              parseFloat(
                                                summary?.grandTotal || 0
                                              )?.toFixed(2)
                                            )} */}
                                        </th>
                                      )}
                                      {selectedValues?.columns?.includes(
                                        "Remarks"
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "11%",
                                            padding: "8px 4px",
                                          }}
                                        ></th>
                                      )}
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </>
                          ) : (
                            <div className="table-empty">
                              <BsTable className="icon" />
                              <p className="text-center text-primary empty-text">
                                No PF Funds data found.
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default PFFundSummaryReport;
